import { useWindowSize } from '@/hooks/useWindowSize';

interface Result {
  isPcSize: boolean;
  isTabletSize: boolean;
  isSmartPhoneSize: boolean;
}

export const useDeviceSize = (): Result => {
  const { width } = useWindowSize();

  const isPcSize = width > 960;
  const isTabletSize = width <= 960 && width > 428;
  const isSmartPhoneSize = width <= 428;

  return { isPcSize, isTabletSize, isSmartPhoneSize };
};
